import {
  connectFirestoreEmulator,
  initializeFirestore,
  persistentLocalCache,
  persistentMultipleTabManager,
} from 'firebase/firestore'
import { firebaseApp } from './firebase'

// Firestore vive en SU PROPIO módulo (no en firebase.ts) a propósito: así el SDK de
// Firestore (~250 kB) no entra al chunk de arranque — el login solo necesita Auth.
// Solo rt.ts y la paginación del chat importan de aquí (D-05: listeners únicamente).
export const firestore = initializeFirestore(firebaseApp, {
  localCache: persistentLocalCache({ tabManager: persistentMultipleTabManager() }),
})

if (import.meta.env.VITE_USE_EMULATORS === '1') {
  // Mismo motivo que el puerto de Auth en firebase.ts: configurable por si el 8080
  // ya lo ocupa el emulador de otro repo de la familia.
  connectFirestoreEmulator(firestore, 'localhost', Number(import.meta.env.VITE_FIRESTORE_EMULATOR_PORT || 8080))
}
